import NaluParser from './nalu-parser';
import ExpGolomb from './exp-golomb.js';

class PPSParser extends NaluParser {
    static parsePPS(uint8array: Uint8Array) {
        let pps: any = {};

        let rbsp = PPSParser._ebsp2rbsp(uint8array);
        let gb = new ExpGolomb(rbsp);

        gb.readByte(); // skip nal unit header

        pps.pic_parameter_set_id = gb.readUEG();
        pps.seq_parameter_set_id = gb.readUEG();
        pps.entropy_coding_mode_flag = gb.readBits(1);
        pps.bottom_field_pic_order_in_frame_present_flag = gb.readBits(1);
        let num_slice_groups_minus1 = pps.num_slice_groups_minus1 = gb.readUEG();

        if (num_slice_groups_minus1 > 0) {
            let slice_group_map_type = pps.slice_group_map_type = gb.readUEG();

            if (slice_group_map_type === 0) {
                for (let iGroup = 0; iGroup <= num_slice_groups_minus1; iGroup++) {
                    gb.readUEG(); // run_length_minus1[ iGroup ]
                }
            } else if (slice_group_map_type === 2) {
                for (let iGroup = 0; iGroup <= num_slice_groups_minus1; iGroup++) {
                    gb.readUEG(); // top_left[ iGroup ]
                    gb.readUEG(); // bottom_right[ iGroup ]
                }
            } else if (slice_group_map_type === 3 || slice_group_map_type === 4 || slice_group_map_type === 5) {
                pps.slice_group_change_direction_flag = gb.readBits(1); // slice_group_change_direction_flag
                pps.slice_group_change_rate_minus1 = gb.readUEG(); // slice_group_change_rate_minus1
            } else if (slice_group_map_type === 6) {
                let pic_size_in_map_units_minus1 = gb.readUEG();
                for (let i = 0; i <= pic_size_in_map_units_minus1; i++) {
                    let numBits = Math.ceil(Math.log2(num_slice_groups_minus1 + 1));
                    gb.readBits(numBits); // slice_group_id[ i ]
                }
            }
        }

        pps.num_ref_idx_l0_default_active_minus1 = gb.readUEG();
        pps.num_ref_idx_l1_default_active_minus1 = gb.readUEG();
        pps.weighted_pred_flag = gb.readBits(1);
        pps.weighted_bipred_idc = gb.readBits(2);
        pps.pic_init_qp_minus26 = gb.readSEG();
        pps.pic_init_qs_minus26 = gb.readSEG();
        pps.chroma_qp_index_offset = gb.readSEG();
        pps.deblocking_filter_control_present_flag = gb.readBits(1);
        pps.constrained_intra_pred_flag = gb.readBits(1);
        pps.redundant_pic_cnt_present_flag = gb.readBits(1);

        // TODO: if (more_rbsp_data())

        gb.destroy();
        gb = null;

        return pps;
    }
}

export default PPSParser;
